module.exports = __webpack_public_path__ + "fonts/Source_Sans_3-normal-400-greek-ext.d413bc8.woff2";